import { AssetsDetails } from "@evidenceb/athena-common/modules/Assets";
import { useContext, useMemo } from "react";
import { configStore } from "../contexts/ConfigContext";
import { sessionStore } from "../contexts/SessionContext";
import appConfig from "../config";

const useAssetsDetails = (
    { forGameplay }: { forGameplay: boolean } = { forGameplay: false }
) => {
    const {
        config: { apiUrls },
    } = useContext(configStore);
    const {
        session: { version },
    } = useContext(sessionStore);

    const assetsDetails = useMemo<AssetsDetails>(
        () => ({
            version,
            contentUrl: apiUrls.endpoints.assetsProxy,
            folderpath: forGameplay ? "content/" : "interface/",
            basePath: appConfig.basePath,
        }),
        [version, apiUrls, forGameplay]
    );

    return assetsDetails;
};

export default useAssetsDetails;
